import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import pt from 'vuetify/lib/locale/pt';

Vue.use(Vuetify);

export default new Vuetify({
  lang: {
    locales: { pt },
    current: 'pt',
  },
  theme: {
    options: { customProperties: true },
    themes: {
      light: {
        primary: '#00615c',
        secondary: '#388E3C',
        default: '#78909c',
        accent: '#e54304',
        success: '#419641',
        warning: '#ff9a03',
        error: '#b92732',
        background: '#ffffff',
        text: '#424242',
      },
      dark: {
        primary: '#003D40',
        secondary: '#388E3C',
        default: '#bdcac5',
        accent: '#BF360C',
        success: '#419641',
        warning: '#ff9a03',
        error: '#b92732',
        background: '#2f2f31',
        text: '#8BC753',
      },
    },
  },
});
